module.exports = __webpack_public_path__ + "static/media/carousel2.67224761.jpg";